// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  list-style: none;
  padding-right: 25px;
}

.sidenav-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed; /* Make it sticky */
  top: 50%; /* Center it vertically */
  right: 0; /* Align it to the right */
  transform: translateY(-50%); /* Center it vertically */
}

.sidenav-2 .icon-content {
  margin: 6px 0; /* Adjusted margin for vertical spacing */
  position: relative;
  padding: 0.5rem;
}

.sidenav-2 .icon-content .tooltip {
  position: absolute;
  top: 100%;
  right: 90%;
  transform: translateY(125%);
  color: #fff;
  padding: 6px 10px;
  border-radius: 10px;
  opacity: 0;
  visibility: hidden;
  font-size: 18px;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  /* width: 100px; */
}

.sidenav-2 .icon-content:hover .tooltip {
  opacity: 1;
  visibility: visible;
  top: -50px;
}

.sidenav-2 .icon-content button {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #4d4d4d;
  background-color: #706b6b;
  transition: all 0.1s ease-in-out;
  border: none;
  cursor: pointer;
}

.sidenav-2 .icon-content button .filled {
  position: absolute;
  top: auto;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background: linear-gradient(150deg, #0c27aa, #961a96, #720a0a);
  transition: all 0.1s ease-in-out;
}

.sidenav-2 .icon-content button:hover .filled,
.sidenav-2 .icon-content button.filled .filled {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/asset/css/Sidenav.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe,EAAE,mBAAmB;EACpC,QAAQ,EAAE,yBAAyB;EACnC,QAAQ,EAAE,0BAA0B;EACpC,2BAA2B,EAAE,yBAAyB;AACxD;;AAEA;EACE,aAAa,EAAE,yCAAyC;EACxD,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,OAAO;EACP,WAAW;EACX,SAAS;EACT,8DAA8D;EAC9D,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;AACd","sourcesContent":["ul {\n  list-style: none;\n  padding-right: 25px;\n}\n\n.sidenav-2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  position: fixed; /* Make it sticky */\n  top: 50%; /* Center it vertically */\n  right: 0; /* Align it to the right */\n  transform: translateY(-50%); /* Center it vertically */\n}\n\n.sidenav-2 .icon-content {\n  margin: 6px 0; /* Adjusted margin for vertical spacing */\n  position: relative;\n  padding: 0.5rem;\n}\n\n.sidenav-2 .icon-content .tooltip {\n  position: absolute;\n  top: 100%;\n  right: 90%;\n  transform: translateY(125%);\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 10px;\n  opacity: 0;\n  visibility: hidden;\n  font-size: 18px;\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;\n  /* width: 100px; */\n}\n\n.sidenav-2 .icon-content:hover .tooltip {\n  opacity: 1;\n  visibility: visible;\n  top: -50px;\n}\n\n.sidenav-2 .icon-content button {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  color: #4d4d4d;\n  background-color: #706b6b;\n  transition: all 0.1s ease-in-out;\n  border: none;\n  cursor: pointer;\n}\n\n.sidenav-2 .icon-content button .filled {\n  position: absolute;\n  top: auto;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 0;\n  background: linear-gradient(150deg, #0c27aa, #961a96, #720a0a);\n  transition: all 0.1s ease-in-out;\n}\n\n.sidenav-2 .icon-content button:hover .filled,\n.sidenav-2 .icon-content button.filled .filled {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
